import type { FC } from 'react';
import { Typography } from '@mui/material';

import { StyledStatusPill } from './StatusPill.styled';
import type { TStatusPillVariant } from './types';

export interface IStatusPillProps {
	text: string;
	variant: TStatusPillVariant;
	dataTestId?: string;
}

export const StatusPill: FC<IStatusPillProps> = ({
	text,
	variant,
	dataTestId,
}) => {
	return (
		<StyledStatusPill variant={variant} data-testid={dataTestId}>
			<Typography variant="l1-m" color="inherit">
				{text}
			</Typography>
		</StyledStatusPill>
	);
};
